import aiGenerateService from '@services/aiGenerateService.js';

const state = {
  isInitPluginMakewebeasyAI: undefined,
  typePrompt: 'text',
  prompt : {
    text : {
      tone : undefined,
      suggestion : undefined,
      action : undefined
    },
  },
  loading: {
    text: {
      tone: false,
      suggestion: false,
      action: false,
    }
  }
}

const getters = {
  isInitPluginMakewebeasyAI: state => state.isInitPluginMakewebeasyAI,
  typePrompt: state => state.typePrompt,
  prompts: state => state.prompt,
  loadings: state => state.loading,
  prompt: state => state.prompt[state.typePrompt],
  loading: state => state.loading[state.typePrompt],
}

const mutations = {
  SET_IS_INIT_PLUGIN_MAKEWEBEASY_AI(state, { isInitPluginMakewebeasyAI }) {
    state.isInitPluginMakewebeasyAI = isInitPluginMakewebeasyAI;
  },
  SET_PROMPT(state, { type, subType, prompt }) {
    state.prompt[type][subType] = prompt;
  },
  SET_TYPE_PROMPT(state, { typePrompt }) {
    state.typePrompt = typePrompt;
  },
  SET_LOADING(state, { type, subType, loading }) {
    state.loading[type][subType] = loading;
  },
}

const actions = {
  init: ({ dispatch }) => {
    dispatch('fetchPrompt', { type: state.typePrompt, subType: 'tone' });
    dispatch('fetchPrompt', { type: state.typePrompt, subType: 'suggestion' });
  },
  async checkInitPluginMakewebeasyAI({ commit }) {
    const response = await aiGenerateService.checkInitPluginMakewebeasyAI().catch(() => { return null});
    commit('SET_IS_INIT_PLUGIN_MAKEWEBEASY_AI', { isInitPluginMakewebeasyAI: response && response.success && response.data ? response.data.isActive : false });
  },
  async fetchPrompt({ commit, dispatch }, { type, subType }) {
    let response = null;
    if(type === 'text') {
      response = await dispatch('fetchPromptText', { subType })
    }

    if (response && response.success && response.data) {
      commit('SET_PROMPT', { type, subType, prompt: response.data });
    }else{
      commit('SET_PROMPT', { type, subType, prompt: [] });
    }
  },
  async fetchPromptText ({ commit }, { subType }) {
    commit('SET_LOADING', { type: 'text', subType, loading: true });
    let response = null;
    switch (subType) {
      case 'tone':
        response = await aiGenerateService.getContentTone().catch(() => { return null})
        break;
      case 'suggestion':
        response = await aiGenerateService.getSuggestPrompt().catch(() => { return null})
        break;
      default:
        response = null
    }
    commit('SET_LOADING', { type: 'text', subType, loading: false });
    return response;
  },
  setTypePrompt: ({ commit }, { typePrompt }) => {
    commit('SET_TYPE_PROMPT', { typePrompt });
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};